import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import RequisitionFormContMain from "presentation/view/container/RequisitionForm/RequisitionFormContMain";

CommonEntrypoint(<RequisitionFormContMain/>)